import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchPunctualContractInvoice = (id) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id, authorization())
	.then(checkStatus)
	.then((res) => res.blob());
};

export const sendPunctualContractInvoice = (id) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id, authorization({
		method: 'POST'
	}))
	.then(checkStatus)
	.then((res) => res.json());
}

export const updatePunctualContractInvoice = (id, changes) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removePunctualContractInvoice = (id) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
};

export const addPunctualContractInvoiceModification = (id, modif) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id + '/modifications', authorization({
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(modif)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removePunctualContractInvoiceModification = (id, modifId) => {
	return fetch(apiBasename + '/punctualContractInvoice/' + id + '/modifications/' + modifId, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
}

